"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _SearchModal = _interopRequireDefault(require("./SearchModal"));
var _reactBlueprintLibrary = require("react-blueprint-library");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react-hooks/rules-of-hooks */

var SearchResultsList = props => {
  var [show, setShow] = (0, _react.useState)(false);
  var handleShow = () => setShow(true);
  var handleHide = () => setShow(false);
  var onChange = (page, event) => {
    var urlPath = props.fields.searchUrl.value;
    if (props.filters.length) {
      window.history.pushState({
        path: "".concat(urlPath, "?query=").concat(props.searchterm, "&type=").concat(props.filters, "&page=").concat(page)
      }, '', "".concat(urlPath, "?query=").concat(props.searchterm, "&type=").concat(props.filters, "&page=").concat(page));
    } else {
      window.history.pushState({
        path: "".concat(urlPath, "?query=").concat(props.searchterm, "&page=").concat(page)
      }, '', "".concat(urlPath, "?query=").concat(props.searchterm, "&page=").concat(page));
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    props.onPagingClick(page);
  };
  var noresults = totresults => {
    if (totresults <= 0) {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("p", {
        className: "sm-head space-above-md space-below-lg"
      }, props.fields.noresultsMessage.value));
    }
    ;
  };
  var recordCount = itemsTotal => {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", null, props.fields.searchMessage.value), /*#__PURE__*/_react.default.createElement("div", {
      className: "search-result-meta row space-below-xs"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "text-left col-sm-12"
    }, /*#__PURE__*/_react.default.createElement("span", {
      "aria-live": "polite",
      role: "alert"
    }, "Found ".concat(itemsTotal, " '").concat(props.searchterm, "' Items")), " ", /*#__PURE__*/_react.default.createElement("a", {
      href: "#filter-for-search",
      className: "text-left sr-only sr-only-focusable"
    }, "Skip to filters"))), /*#__PURE__*/_react.default.createElement("hr", null), noresults(itemsTotal));
  };
  return /*#__PURE__*/_react.default.createElement("div", null, recordCount(props.totalItems), /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-group list-group-flush"
  }, (0, _lodash.map)(props.resultitms, (item, idx) => {
    var title = item.title;
    var link = item.url;
    if (item.title.length === 0) {
      // if title is not available, use the link as the title
      title = link;
    }
    return /*#__PURE__*/_react.default.createElement("li", {
      key: "li_".concat(idx),
      className: "list-group-item"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "list-item-preview-text"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: item.url,
      target: "_self"
    }, title), /*#__PURE__*/_react.default.createElement("p", null, item.description)));
  })), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Pagination, {
    currentPage: props.page,
    itemsPerPage: 10,
    numberOfItems: props.totalItems,
    onChange: onChange
  }));
};
var _default = exports.default = SearchResultsList;